export function getActionCardStyles(props) {
    const { theme } = props;
    const styles = {
        root: { minHeight: 78 },
        primaryText: {
            fontSize: theme.fonts.medium.fontSize,
        },
        contentWrapper: {
            paddingTop: 8,
            paddingBottom: 8,
        },
        subComponentStyles: {
            mainIcon: {
                root: {
                    gridRowEnd: 'span 2',
                },
            },
            iconButton: {},
        },
    };
    return styles;
}
//# sourceMappingURL=ActionCard.styles.js.map